export default __webpack_public_path__ + "static/media/14.a64ef2bc.jpg";